import deburr from 'lodash.deburr'

export function slugify(string) {
	string = deburr(string)
	string = string.trim().toLowerCase()
	string = string.replace(/[^a-z]/g, '-')
	string = string.replace(/-+/g, '-')
	return string
}
